var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDocumentsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 233,
    viewBox: "0 0 286 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 224.156 197.618)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 279.277,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 -147.566 221.846)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 87.0703 154.564)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 234.905,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 -28.1328 269.953)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 288.073,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 -33.7734 113.05)",
    fill: "#435E64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocumentsLeft);
export default __webpack_public_path__ + "static/media/no-documents-left.103c06fb23df794b5dd4b207a9c4aee6.svg";
export { ForwardRef as ReactComponent };